/* eslint-disable complexity */
import React from 'react';
import Button from 'carbon-react/lib/components/button';

import { FormattedMessage } from '@futrli/localisation';

import { FILTER_TYPE, TABLE_COLUMN } from '../filter-table-types';
import { isFilterSubmitDisabled } from '../filter-table-helper';

interface FilterActionsProps {
  checkedFilteredData?: Record<string, boolean>;
  handleSubmit: () => void;
  handleClose: () => void;
  filterType?: FILTER_TYPE;
  fromValue?: string;
  toValue?: string;
  fromDate?: Date;
  toDate?: Date;
  fromTime?: string;
  toTime?: string;
  activeColumn?: TABLE_COLUMN;
  selectedValues?: Record<string, boolean>;
}

export const FilterActions = ({
  checkedFilteredData,
  handleClose,
  handleSubmit,
  fromValue,
  toValue,
  fromDate,
  toDate,
  fromTime,
  toTime,
  activeColumn,
  filterType,
  selectedValues
}: FilterActionsProps) => (
  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
    <Button
      buttonType="primary"
      mr="8px"
      disabled={isFilterSubmitDisabled({
        fromValue,
        toValue,
        fromDate,
        toDate,
        activeColumn,
        selectedValues,
        checkedFilteredData,
        filterType,
        fromTime,
        toTime
      })}
      onClick={handleSubmit}
    >
      <FormattedMessage id="common.ok" defaultMessage="OK" />
    </Button>
    <Button buttonType="secondary" onClick={handleClose}>
      <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
    </Button>
  </div>
);
